import clsx from 'clsx';
import styles from './WidgetBox.module.scss';

interface WidgetFormProps {
  children: React.ReactNode;
  className?: string;
}

export const WidgetBox = ({ children, className }: WidgetFormProps) => (
  <aside className={clsx(styles.box, className)}>{children}</aside>
);
